import React, { useEffect, useState } from "react";
import { Table, Input, Button } from "antd";
import { useTableSearch } from "../tablas/useTableSearch";
import jsPDF from "jspdf";
import axios from "axios";
import "jspdf-autotable";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { useMediaQuery } from "react-responsive";
import { DownloadOutlined, SearchOutlined, DownOutlined } from "@ant-design/icons";
const { Search } = Input;

export const TablaCompleta = ({
  fetchDatos,
  columns,
  elScroll,
  tituloPDF,
  gestionTabla,
  rowKey,
  mostrarBoton = true, // Por defecto, el botón de descarga está visible
  mostrarBuscador = true, // Por defecto, el buscador está visible
  filtrarUltimaColumna = true,
  mostrarFiltrador = false,
  filasPorPagina = 30,
  idAsociacion,
  tituloBanner = "",
  idCategoria,
  customMargin,
  esNotificaciones,
  claseRaiz = "", // clase extra para darle otro estilo a la tabla desde el CSS
  mostrarSelectorFilas = false, // muestra el selector "Mostrar [10]" para elegir cuántas filas ver
  onFilaClick, // si se pasa, al hacer click en una fila se llama con los datos de esa fila
}) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filasActuales, setFilasActuales] = useState(filasPorPagina);
  useEffect(() => {
    setFilasActuales(filasPorPagina);
  }, [filasPorPagina]);
  const opcionesFilas = [...new Set([10, 20, 30, 50, filasPorPagina])].sort((a, b) => a - b);
  const { filteredData, loading } = useTableSearch({
    searchVal,
    retrieve: fetchDatos,
  });
  const [filtrosPilotos, setFiltrosPilotos] = useState({ desde: "", hasta: "" })
  let datosFiltradosPorOrden = [...filteredData];
  const desde = parseInt(filtrosPilotos.desde);
  const hasta = parseInt(filtrosPilotos.hasta);

  if (!isNaN(desde) && !isNaN(hasta)) {
    datosFiltradosPorOrden = datosFiltradosPorOrden.filter(
      (item) => item.orden >= desde && item.orden <= hasta
    );
  }

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    overflow: "auto",
  };

  const exportToPDF = async () => {
    const ahora = new Date();
    const fecha = `${ahora.getDate()}/${ahora.getMonth() + 1}/${ahora.getFullYear()}`;
    const hora = `${ahora.getHours()}:${ahora.getMinutes()}:${ahora.getSeconds()}`;

    const doc = new jsPDF();

    if (mostrarBoton) {
      let asociacionesData;
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/asociacion-detalles/${idAsociacion}`);

      if (response.status === 200) {
        asociacionesData = response.data;
        // console.log("asoc", asociacionesData)
      }
      // console.log("nombre", nombreCategoria)
      const titulo = tituloBanner;
      const nombreAsociacion = asociacionesData.nombre;
      let nombreCategorias = "";
      if (idCategoria) {
        try {
          const responseCategoria = await axios.get(`${process.env.REACT_APP_DOMINIO}/categoria/${idCategoria}`);
          nombreCategorias = responseCategoria.data.categoria || "";
        } catch (error) {
          console.error("Error al obtener el nombre de la categoría", error);
        }
      }
      let logoUrl = asociacionesData.imagen && asociacionesData.imagen !== "null"
        ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idAsociacion}/IMAGENES/ASOCIACIONES/${asociacionesData.imagen}`
        : "/img/logo-mundo-piloto.png";

      const getBase64Image = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      };

      const logoBase64 = await getBase64Image(logoUrl);

      doc.addImage(logoBase64, "PNG", 10, 10, 45, 30);
      doc.setFontSize(18);
      doc.text(titulo, doc.internal.pageSize.width / 2, 20, { align: "center" });
      doc.setFontSize(14);
      doc.text(nombreCategorias, doc.internal.pageSize.width / 2, 38, { align: "center" });
      doc.setFontSize(12);
      doc.text(nombreAsociacion, doc.internal.pageSize.width / 2, 28, { align: "center" });

      doc.setFontSize(10);
      doc.text(`Fecha: ${fecha}`, doc.internal.pageSize.width - 10, 10, { align: "right" });
    }

    const filteredColumns = filtrarUltimaColumna ? columns.slice(0, -1) : columns;
    const columnHeaders = filteredColumns.map((col) =>
      typeof col.title === "function"
        ? col.title().props.children.props.children
        : col.title
    );

    if (esNotificaciones) {
      // --- helpers PDF (pegarlos arriba de exportToPDF, dentro del componente) ---
      const extractTextFromReact = (node) => {
        if (node === null || node === undefined || typeof node === "boolean") return "";
        if (typeof node === "string" || typeof node === "number") return String(node);

        // arrays
        if (Array.isArray(node)) return node.map(extractTextFromReact).join(" ").trim();

        // React element
        if (React.isValidElement(node)) {
          return React.Children.toArray(node.props?.children)
            .map(extractTextFromReact)
            .join(" ")
            .trim();
        }

        // objects (moment, dayjs, etc.)
        if (typeof node === "object") {
          try {
            return String(node);
          } catch {
            return "";
          }
        }

        return "";
      };

      // saca emojis y caracteres que helvetica no puede renderizar bien
      const sanitizePdfText = (text) => {
        if (text === null || text === undefined) return "-";
        let s = String(text);

        // 1) remover emojis (la causa principal del "texto raro")
        try {
          s = s.replace(/\p{Extended_Pictographic}/gu, "");
        } catch {
          // fallback si el entorno no soporta \p{}
          s = s.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, "");
        }

        // 2) remover controles raros
        s = s.replace(/[\u0000-\u001F\u007F]/g, " ");

        // 3) colapsar espacios
        s = s.replace(/\s+/g, " ").trim();

        return s.length ? s : "-";
      };

      const getCellValueForPdf = (col, row) => {
        if (col.key === "orden") return sanitizePdfText(row?.orden ?? "-");

        const dataKey = col.dataIndex ?? col.key;
        const raw = dataKey ? row?.[dataKey] : undefined;

        // helper: intenta render y devuelve texto (o "")
        const tryRender = (fn, ...args) => {
          try {
            const rendered = fn(...args);
            const text = sanitizePdfText(extractTextFromReact(rendered));
            return text === "-" ? "" : text; // si quedó vacío lo tratamos como ""
          } catch {
            return "";
          }
        };

        if (typeof col.render === "function") {
          // ✅ 1) Firma AntD: render(value, record, index)
          const t1 = tryRender(col.render, raw, row, 0);
          if (t1) return t1;

          // ✅ 2) Firma legacy de tu proyecto: render(record)
          const t2 = tryRender(col.render, row);
          if (t2) return t2;

          // ✅ 3) fallback: raw sin render
          return sanitizePdfText(extractTextFromReact(raw));
        }

        return sanitizePdfText(extractTextFromReact(raw));
      };

      const formattedData = datosFiltradosPorOrden.map((row) =>
        filteredColumns.map((col) => getCellValueForPdf(col, row))
      );

      doc.autoTable({
        head: [columnHeaders],
        body: formattedData,
        startY: 50,
        styles: {
          fillColor: [255, 255, 255],
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [34, 52, 99],
          textColor: [255, 255, 255],
          cellPadding: 3,
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        columnStyles: {
          0: { minCellWidth: 35, halign: "center" },
          ...filteredColumns.reduce((styles, col, index) => {
            if (index === 0) return styles;
            const isNumericColumn = formattedData.every(
              (row) => !isNaN(row[index]) && row[index] !== " "
            );
            if (isNumericColumn) {
              styles[index] = { halign: "left" };
            }
            return styles;
          }, {}),
        },

        /** 👇 acá se hace la magia */
        didDrawCell: function (data) {
          if (data.section === "head") {
            const { cell, column, row } = data;
            const docC = data.doc;
            const radius = 6;

            // Primera celda (esquina superior izquierda)
            if (column.index === 0 && row.index === 0) {
              const { x, y, width, height } = cell;
              docC.setFillColor(34, 52, 99);
              docC.setDrawColor(34, 52, 99);

              docC.roundedRect(x, y, width, height, radius, radius, "F");
              docC.setTextColor(255, 255, 255);
              docC.text(cell.text[0], x + width / 2, y + height / 2, {
                align: "center",
                baseline: "middle",
              });
            }

            // Última celda (esquina superior derecha)
            if (
              column.index === row.cells.length - 1 &&
              row.index === 0
            ) {
              const { x, y, width, height } = cell;
              docC.setFillColor(34, 52, 99);
              docC.setDrawColor(34, 52, 99);

              docC.roundedRect(x, y, width, height, radius, radius, "F");
              docC.setTextColor(255, 255, 255);
              docC.text(cell.text[0], x + width / 2, y + height / 2, {
                align: "center",
                baseline: "middle",
              });
            }
          }
        },

        didDrawPage: (data) => {
          const pageCount = doc.internal.getNumberOfPages();
          doc.setFontSize(10);
          doc.text(
            `Página ${data.pageNumber} de ${pageCount}`,
            doc.internal.pageSize.width - 10,
            doc.internal.pageSize.height - 10,
            { align: "right" }
          );
        },
      });

      doc.save(`${tituloPDF}_${fecha.replace(/\//g, "-")}_${hora.replace(/:/g, "-")}.pdf`);

    } else {
      const formattedData = datosFiltradosPorOrden.map((row) =>
        filteredColumns.map((col) => {
          if (col.key === "orden") {
            return row.orden ? String(row.orden) : "-";
          }
      
          let value = col.render ? col.render(row) : row[col.key];
      
          if (React.isValidElement(value)) {
            if (value.type === "div" && value.props.children) {
              const childrenArray = React.Children.toArray(value.props.children);
              const inputElement = childrenArray.find(
                (child) => React.isValidElement(child) && child.type === "input"
              );
              value = inputElement
                ? inputElement.props.value || ""
                : childrenArray.map((child) => (typeof child === "string" ? child : "")).join(" ");
            } else {
              value = React.Children.toArray(value.props.children)
                .map((child) => (typeof child === "string" ? child : ""))
                .join(" ");
            }
          } else if (typeof value === "object" && value !== null) {
            value = value.toString ? value.toString() : "";
          }
      
          return typeof value === "string" ? value : String(value);
        })
      );

      doc.autoTable({
        head: [columnHeaders],
        body: formattedData,
        startY: 50,
        styles: {
          fillColor: [255, 255, 255],
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [34, 52, 99],
          textColor: [255, 255, 255],
          cellPadding: 3,
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        columnStyles: {
          0: { minCellWidth: 35, halign: "center" },
          ...filteredColumns.reduce((styles, col, index) => {
            if (index === 0) return styles;
            const isNumericColumn = formattedData.every(
              (row) => !isNaN(row[index]) && row[index] !== " "
            );
            if (isNumericColumn) {
              styles[index] = { halign: "left" };
            }
            return styles;
          }, {}),
        },

        /** 👇 acá se hace la magia */
        didDrawCell: function (data) {
          if (data.section === "head") {
            const { cell, column, row } = data;
            const docC = data.doc;
            const radius = 6;

            // Primera celda (esquina superior izquierda)
            if (column.index === 0 && row.index === 0) {
              const { x, y, width, height } = cell;
              docC.setFillColor(34, 52, 99);
              docC.setDrawColor(34, 52, 99);

              docC.roundedRect(x, y, width, height, radius, radius, "F");
              docC.setTextColor(255, 255, 255);
              docC.text(cell.text[0], x + width / 2, y + height / 2, {
                align: "center",
                baseline: "middle",
              });
            }

            // Última celda (esquina superior derecha)
            if (
              column.index === row.cells.length - 1 &&
              row.index === 0
            ) {
              const { x, y, width, height } = cell;
              docC.setFillColor(34, 52, 99);
              docC.setDrawColor(34, 52, 99);

              docC.roundedRect(x, y, width, height, radius, radius, "F");
              docC.setTextColor(255, 255, 255);
              docC.text(cell.text[0], x + width / 2, y + height / 2, {
                align: "center",
                baseline: "middle",
              });
            }
          }
        },

        didDrawPage: (data) => {
          const pageCount = doc.internal.getNumberOfPages();
          doc.setFontSize(10);
          doc.text(
            `Página ${data.pageNumber} de ${pageCount}`,
            doc.internal.pageSize.width - 10,
            doc.internal.pageSize.height - 10,
            { align: "right" }
          );
        },
      });

      doc.save(`${tituloPDF}_${fecha.replace(/\//g, "-")}_${hora.replace(/:/g, "-")}.pdf`);
    }

  };

  const handleSearchChange = (value) => {
    setSearchVal(value); // Actualiza el estado del buscador
  };
  const esTelefono = useMediaQuery({ maxWidth: 768 });
  return (
    <div style={containerStyle} className={claseRaiz}>
      {/* Contenedor para los botones */}
      <div
        style={{
          display: "flex",
          flexDirection: "column", //
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div
          className="tabla-herramientas"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: customMargin || "1em",
            width: "100%",
            gap: "10px"
          }}
        >
          {/* Buscador (solo si mostrarBuscador es true) */}
          {mostrarBuscador && (
            <Search
              placeholder="Buscar en la tabla"
              allowClear
              enterButton={
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#223463",
                    fontSize: "17px",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    marginLeft: "1em",
                    fontFamily: "system-ui"
                  }}
                >
                  {esTelefono ? <SearchOutlined /> : "Buscar"}
                </Button>
              }
              size="medium"
              onSearch={handleSearchChange}
              className="search"
              style={{
                maxWidth: "600px",
                // height: "2em",
                fontSize: "0.8em",
              }}
            />
          )}

          <div style={{ display: "flex", gap: "10px", marginTop: "0" }}>
            {/* Botón para exportar a PDF (solo si mostrarBoton es true) */}
            {(mostrarBoton || gestionTabla) && (
              <>
                {mostrarBoton && (
                  <BotonPrincipal
                    onClick={exportToPDF}
                    texto={esTelefono ? <DownloadOutlined /> : "Descargar"}
                    Descargar
                    tabla
                  />
                )}
                {gestionTabla}
              </>
            )}
            {mostrarSelectorFilas && (
              <label className="tabla-selector-filas">
                <select
                  value={filasActuales}
                  onChange={(e) => setFilasActuales(Number(e.target.value))}
                  aria-label="Filas por página"
                >
                  {opcionesFilas.map((n) => (
                    <option key={n} value={n}>
                      Mostrar [{n}]
                    </option>
                  ))}
                </select>
                <DownOutlined />
              </label>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "1em",
            width: "100%",
            gap: "10px"
          }}
          >
          {mostrarFiltrador && (
            <>
              <input
                type="number"
                placeholder="Desde"
                className="input-form"
                value={filtrosPilotos.desde || ""}
                onChange={(e) =>
                  setFiltrosPilotos((prev) => ({
                    ...prev,
                    desde: e.target.value,
                  }))
                }
              />
              <input
                type="number"
                placeholder="Hasta"
                className="input-form"
                value={filtrosPilotos.hasta || ""}
                onChange={(e) =>
                  setFiltrosPilotos((prev) => ({
                    ...prev,
                    hasta: e.target.value,
                  }))
                }
              />
            </>
          )}
        </div>
        {/* Tabla */}
        <Table
          translate="no" 
          className="notranslate"
          rowKey={rowKey ? rowKey : "id"}
          dataSource={datosFiltradosPorOrden}
          columns={columns}
          loading={loading}
          scroll={elScroll}
          pagination={{ position: ["bottomCenter"], pageSize: filasActuales }}
          size="small"
          rowClassName={() => (onFilaClick ? "custom-row fila-clickeable" : "custom-row")}
          onRow={onFilaClick ? (registro) => ({ onClick: () => onFilaClick(registro) }) : undefined}
        />
      </div>
    </div>
  );
};
